<template>
  <div id="app">
    <header>
      <nav class="navbar navbar-expand-lg navbar-light fixed-top">
        <div class="container">
          <a class="navbar-brand" href="#home">
            <img src="../src/assets/images/logo_da.png" alt="Logo" class="logo">
          </a>
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav mr-auto">
              <li class="nav-item">
                <a class="nav-link" href="#home" @click.prevent="scrollToSection('home')">Home</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#about" @click.prevent="scrollToSection('about')">About Me</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#services" @click.prevent="scrollToSection('services')">My Services</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#schedule" @click.prevent="scrollToSection('schedule')">Schedule</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#blog" @click.prevent="scrollToSection('blog')">Blog</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#test" @click.prevent="openTestModal">
                  Have a Test
                  <span class="badge badge-dark">new</span>
                </a>
              </li>
            </ul>
            <form class="form-inline my-2 my-lg-0 mr-3" v-if="!$route.meta.hideSearch">
              <div class="search-box">
                <input class="form-control" type="search" placeholder="Search by inspiration" aria-label="Search">
                <button class="btn search-btn" type="submit">
                  <i class="fas fa-search"></i>
                </button>
              </div>
            </form>
            <div class="auth-buttons" v-if="!currentUser">
              <a href="#" class="btn btn-link" data-toggle="modal" data-target="#loginModal">Log in</a>
              <a href="#" class="btn btn-primary" data-toggle="modal" data-target="#signupModal">Sign Up</a>
            </div>
            <div class="user-info" v-else>
              <span class="welcome-text">Hello, {{ currentUser.username }}</span>
              <!-- 移除了 data-toggle 和 data-target 属性 -->
              <button class="btn btn-link" @click="handleLogout">Logout</button>
            </div>
          </div>
        </div>
      </nav>
    </header>

    <main>
      <section id="home">
        <Home />
      </section>
      <section id="about">
        <AboutMe />
      </section>
      <section id="services">
        <MyServices />
      </section>
      <section id="schedule">
        <Schedule />
      </section>
      <section id="blog">
        <Blog />
      </section>
      <section id="reviews">
        <Reviews />
      </section>
      <TestModal :visible="showTestModal" @close="showTestModal = false" />
    </main>

    <Contact />
    
    <footer class="site-footer">
      <div class="footer-content">
        <div class="footer-left">
          <img src="../src/assets/images/logo_da.png" alt="Logo" class="footer-logo">
          <nav class="footer-nav">
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About Me</a></li>
              <li><a href="#services">My Services</a></li>
              <li><a href="#blog">Blog</a></li>
              <li><a href="#schedule">Schedule</a></li>
              <li><a href="#test">Have a Test</a></li>
            </ul>
          </nav>
        </div>
        <div class="footer-right">
          <h3>Follow Us</h3>
          <div class="social-links">
            <a href="#" class="social-link">
              <i class="fab fa-facebook-f"></i>
            </a>
            <a href="#" class="social-link">
              <i class="fab fa-twitter"></i>
            </a>
            <a href="#" class="social-link">
              <i class="fab fa-instagram"></i>
            </a>
            <a href="#" class="social-link">
              <i class="fab fa-tiktok"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <p>&copy; 2023 Zeinglish. All rights reserved.</p>
      </div>
    </footer>
    
    <SignUpModal />
    <LoginModal />
  </div>
</template>

<script>
import Home from './views/Home.vue'
import AboutMe from './views/AboutMe.vue'
import MyServices from './views/MyServices.vue'
import Schedule from './views/Schedule.vue'
import Blog from './views/Blog.vue'
import Reviews from './views/Reviews.vue'
import Contact from './views/Contact.vue'
import SignUpModal from './components/SignUpModal.vue'
import LoginModal from './components/LoginModal.vue'
import TestModal from './components/TestModal.vue'

export default {
  name: 'App',
  components: {
    Home,
    AboutMe,
    MyServices,
    Schedule,
    Blog,
    Contact,
    SignUpModal,
    LoginModal,
    Reviews,
    TestModal
  },
  mounted() {
    document.body.style.overflow = 'auto'
  },
  data() {
    return {
      currentUser: null,
      showTestModal: false
    }
  },
  mounted() {
    // 检查本地存储中是否有用户信息
    const userInfo = localStorage.getItem('userInfo')
    if (userInfo) {
      this.currentUser = JSON.parse(userInfo)
    }
  },
  methods: {
    showToast(type, message) {
      // 修改toast的调用方式
      if (type === 'success') {
        this.$toast.success(message);
      } else if (type === 'error') {
        this.$toast.error(message);
      }
    },
    scrollToSection(sectionId) {
      const section = document.getElementById(sectionId);
      if (section) {
        let offset = 0; // 导航栏的高度
        if(sectionId === 'schedule'){
          offset = -100; // schedule进行一下向上偏移
        }
        const elementPosition = section.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    },
    openTestModal() {
      this.showTestModal = true;
    },
    handleLogout() {
      this.currentUser = null
      localStorage.removeItem('userInfo')
      this.showToast('success', '已成功退出登录')
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  overflow-x: hidden;  /* 防止水平滚动 */
  overflow-y: auto;    /* 允许垂直滚动 */
}

section {
  min-height: 80vh;
  position: relative;
  padding: 60px 0 0;  /* 添加顶部内边距，为固定导航栏留出空间 */
  overflow-y: auto;
}

#home {
  min-height: 100vh;
  padding: 0;  /* 移除首页的内边距 */
  overflow: visible;
}

.section-title {
  margin-top: 1rem;  /* 为标题添加一些额外的上边距 */
  text-align: center;
  margin-bottom: 3rem;
  font-size: 2.5rem;
  color: #2c3e50;
}

.navbar {
  background-color: rgba(255, 255, 255, 0.7);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 0.5rem 0;
  z-index: 1000;
}

.container {
  padding-left: 5%;
  padding-right: 5%;
  width: 100%;
  max-width: none;
}

.navbar .navbar-brand {
  font-weight: 500;
  font-size: 1.5rem;
  color: #333333 !important;
  padding: 0.5rem 0;
  margin-left: 0;
  transition: all 0.3s ease;
}

.navbar .logo {
  height: 40px;
  width: auto;
  margin-right: 10px;
  vertical-align: middle;
}

.navbar-nav {
  margin-right: 2rem;
}

.nav-link {
  font-weight: 700;
  font-size: 1rem;
  color: #666666 !important;
  padding: 1rem 0.8rem !important;  /* 减小内边距 */
  transition: color 0.3s ease;
  white-space: nowrap;  /* 防止文字换行 */
}

.navbar-nav {
  margin-right: 1rem;  /* 减小右边距 */
  flex-wrap: nowrap;   /* 防止导航项换行 */
}
/* 搜索框样式 - 移到媒体查询外面 */
.search-box {
  position: relative;
  display: flex;
  align-items: center;
}

.search-box .form-control {
  width: 220px;
  transition: all 0.3s ease;
  border-radius: 10px;
  padding-right: 35px;
}

.search-box .form-control:focus {
  width: 320px;
}

.search-box .form-control:not(:placeholder-shown) {
  width: 320px;
}

.search-box .search-btn {
  position: absolute;
  right: 10px;
  background: transparent;
  border: none;
  color: #666;
  padding: 0;
}

.search-box .search-btn:hover {
  color: #333;
}

/* 响应式布局优化 */
@media (max-width: 1200px) {
  .nav-link {
    padding: 1rem 0.5rem !important;
    font-size: 0.9rem;
  }
  
  .search-box .form-control {
    width: 150px;
  }
  
  .search-box .form-control:focus,
  .search-box .form-control:not(:placeholder-shown) {
    width: 200px;
  }
}

@media (max-width: 991.98px) {
  .navbar-nav {
    flex-direction: column;  /* 在移动端时改为垂直排列 */
  }
  
  .auth-buttons {
    margin-top: 1rem;
    justify-content: center;
  }
  
  .search-box {
    margin-top: 1rem;
    width: 100%;
  }
  
  .search-box .form-control {
    width: 100%;
  }
}

.site-footer {
  background-color: #000;
  color: #fff;
  padding: 3rem 0 1rem;
}

.footer-content {
  max-width: 100%;
  padding-left: 5%;
  padding-right: 5%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.footer-left {
  display: flex;
  align-items: center;  /* 改为center实现垂直居中 */
  gap: 3rem;
}

.footer-logo {
  height: 40px;  /* 调整为与导航栏logo相同的高度 */
  width: auto;
}

.footer-nav {
  display: flex;
  align-items: center;  /* 确保导航菜单也垂直居中 */
}

.footer-nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  gap: 2rem;
}

.footer-nav a {
  color: #fff;
  text-decoration: none;
  font-size: 1rem;
  transition: color 0.3s ease;
}

.footer-nav a:hover {
  color: #3f51b5;
}

.footer-right {
  text-align: right;
}

.footer-right h3 {
  margin-bottom: 0;  /* 移除底部边距 */
  font-size: 1.2rem;
  display: inline-block;  /* 改为内联块级元素 */
  margin-right: 1rem;  /* 添加右侧边距 */
  vertical-align: middle;  /* 垂直居中对齐 */
}

.social-links {
  display: inline-flex;  /* 改为内联弹性布局 */
  gap: 1rem;
  justify-content: flex-end;
  vertical-align: middle;  /* 垂直居中对齐 */
}

.social-link {
  color: #fff;
  font-size: 1.2rem;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.social-link:hover {
  background-color: #3f51b5;
  color: #fff;
  transform: translateY(-2px);
}

.footer-bottom {
  max-width: 1200px;
  margin: 2rem auto 0;
  padding: 1rem 2rem 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.7);
}

@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    gap: 2rem;
  }

  .footer-left {
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
  }

  .footer-nav ul {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }

  .footer-right {
    text-align: center;
  }

  .footer-right h3 {
    display: block;  /* 在移动端改回块级元素 */
    margin-bottom: 1rem;  /* 在移动端添加底部边距 */
    margin-right: 0;  /* 移除右侧边距 */
  }

  .social-links {
    justify-content: center;
  }
}
</style>

<style scoped>
/* 添加新的样式 */
.user-info {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.welcome-text {
  color: #333;
  font-weight: 500;
}
.test-btn {
  display: block;
  margin: 2rem auto;
  padding: 0.75rem 1.5rem;
  background-color: #333;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 1.1rem;
  cursor: pointer;
  transition: background-color 0.3s;
}

.test-btn:hover {
  background-color: #555;
}

#test {
  text-align: center;
  padding: 3rem 0;
}
</style>